import React from 'react'
import PropTypes from 'prop-types'

const Buttons = ({ next, create, back, allowNext, step, setStep }) => {
  const onNextStep = (e) => {
    if (allowNext) { 
      e.preventDefault()
      setStep(nextStep())
    }
  }

  const onPrevStep = (e) => {
    e.preventDefault()
    setStep(prevStep())
  }

  const nextStep = () => {
    switch (step)
    {
      case 'General Info':
        return 'Team Member'
      case 'Team Member':
        return 'Other'
      default: 
        return 'General Info'
    }
  }

  const prevStep = () => {
    switch (step)
    {
      case 'Team Member':
        return 'General Info'
      case 'Other':
        return 'Team Member'
      default: 
        return 'General Info'
    }
  }

  return <div className='button-section'>
    {back && <button className='team-button back-button' onClick={onPrevStep}>Back</button>}
    {next && <button className='team-button next-button' type='submit' onClick={onNextStep}>Next</button>}
    {create && <button className='team-button next-button' type='submit'>Create</button>}
  </div>
}

Buttons.propTypes = {
  next: PropTypes.bool.isRequired,
  create: PropTypes.bool.isRequired,
  back: PropTypes.bool.isRequired,
  allowNext: PropTypes.bool.isRequired,
  step: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
}

export default Buttons
